/**
 * Convertit un TextStyle (cf. backend Pydantic) en objet style React.
 * Mêmes clés / sémantique que frontend/.../StyledTextField.applyTextStyle.
 *
 *   {font_size, bold, italic, underline, color, text_align}
 */
export function applyTextStyle(textStyle = {}, baseStyle = {}) {
  const out = { ...baseStyle };
  if (textStyle.font_size)  out.fontSize = `${textStyle.font_size}px`;
  if (textStyle.bold)       out.fontWeight = 700;
  if (textStyle.italic)     out.fontStyle = 'italic';
  if (textStyle.underline)  out.textDecoration = 'underline';
  if (textStyle.color)      out.color = textStyle.color;
  if (textStyle.text_align) out.textAlign = textStyle.text_align;
  return out;
}
